import React from 'react';
import { Field } from 'redux-form/immutable';
import { Card } from 'antd';
import MyReactFiles from '../../../utils/MyReactFiles'

// 改用類組件而非函數組件+hooks
class StudImg extends React.Component {
    // 組件掛載時和接收新props時輸出圖片URL，用於調試
    componentDidMount() {
        console.log('StudImg 掛載 - API_SERVER:', API_SERVER);
        console.log('StudImg 掛載 - stud_img:', this.props.stud_img);
        console.log('StudImg 掛載 - studImgValue:', this.props.studImgValue);
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.stud_img !== this.props.stud_img) {
            console.log('StudImg 更新 - 新stud_img:', this.props.stud_img);
        }
        
        if (prevProps.studImgValue !== this.props.studImgValue) {
            console.log('StudImg 更新 - 新studImgValue:', this.props.studImgValue);
        }
    }

    // 檢查圖片地址是否有效
    handleImageError = (e) => {
        console.log('圖片載入失敗', e.target.src);
        // 如果失敗的圖片不是no-image.png，則顯示預設圖片
        if (!e.target.src.includes('no-image.png')) {
            e.target.src = '/images/no-image.png';
        }
    };

    // 簡化的格式化圖片URL，直接參考Guardian1.jsx的實現
    formatImageUrl = (imagePath) => {
        if (!imagePath) return null;
        
        // 如果是完整URL或是資料URI (base64/blob)，直接返回
        if (imagePath.startsWith('http://') || 
            imagePath.startsWith('https://') || 
            imagePath.startsWith('data:') ||
            imagePath.startsWith('blob:')) {
            return imagePath;
        }
        
        // 否則組合API_SERVER與路徑
        const baseUrl = API_SERVER.endsWith('/') ? API_SERVER.slice(0, -1) : API_SERVER;
        const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
        const fullUrl = `${baseUrl}${path}`;
        
        console.log('學生照片 - 組合的圖片URL:', fullUrl);
        return fullUrl;
    };

    render() {
        // 模仿Guardian1.jsx的實現，簡化邏輯
        const imgSrc = this.props.studImgValue ? 
                       (typeof this.props.studImgValue === 'string' ? 
                        this.formatImageUrl(this.props.studImgValue) : 
                        this.props.studImgValue) : 
                       this.props.stud_img ? 
                       this.formatImageUrl(this.props.stud_img) : 
                       '/images/no-image.png';
        
        console.log('StudImg最終使用的URL:', imgSrc);
        
        return (
            <Card title='學生照片上傳'>
                <div className="form-group">
                    <div className="input-group">
                        <p style={{color: 'red'}}>請依上方說明，上傳符合規格之照片。</p>
                        <label>目前圖片</label>
                        <div>
                            <div>
                                <img 
                                    src={imgSrc}
                                    style={{
                                        maxWidth: '300px', 
                                        maxHeight: '300px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        padding: '5px'
                                    }}
                                    alt="student_image"
                                    onError={this.handleImageError}
                                />
                            </div>
                            <div className='text-center mt-20' style={{marginTop: '15px'}}>
                                <Field 
                                    component={MyReactFiles}
                                    name="stud_img_url"
                                    onFilesChange={this.props.changStudImg}
                                    accept={['image/png', 'image/jpeg']}
                                    disabled={this.props.isLocked}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        )
    }
}

export default StudImg



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudImg.jsx